// extracted by mini-css-extract-plugin
export default {"button":"Password_button__cwo2T","buttons":"Password_buttons__xOrYz"};